// extracted by mini-css-extract-plugin
module.exports = {"label":"CardLabel_label__J1l0a","active":"CardLabel_active__UNbp_","nextEpisode":"CardLabel_nextEpisode__3bYmX"};